import PropTypes from "prop-types";
import { useEffect } from "react";

// Layouts
import SingleTiersLoader from "@/Layouts/components/Skeletons/SingleTiersLoader";

// Custom components
import ComposedTiers from "@/PayPlans/components/Commons/ComposedTiers";

// MUI
import { Grid } from "@mui/material";

export default function CashAndLeaseBump(props) {
	const {
		sectionId = "cashAndLeaseBump",
		content = {
			metric: "PVR",
			bonus: false,
			tiers: [],
		},
		loading = false,
		readOnly = false,
		useSectionsErrors = () => {},
		onActionUpdate = () => {},
	} = props;

	const { addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	const handleUpdate = (updatedModel) => {
		onActionUpdate?.(sectionId, null, updatedModel);
	};

	const handleValidation = (isValid) => {
		isValid ? removeSectionError?.(sectionId) : addSectionError?.(sectionId);
	};

	useEffect(() => {
		return () => {
			clearSectionErrors?.(sectionId);
		};
	}, [sectionId, clearSectionErrors]);

	return (
		<Grid container>
			<Grid item xs={12} mt={2.5} px={"32px"}>
				{loading ? (
					<SingleTiersLoader tiers={1} mt={1} buttons sx={{ padding: 0 }} />
				) : (
					<Grid container>
						<Grid item xs={12} className={"models-tiered-area"}>
							<ComposedTiers
								model={content}
								readOnly={readOnly}
								onActionUpdate={handleUpdate}
								onActionValidation={handleValidation}
							/>
						</Grid>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
}
CashAndLeaseBump.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.object,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	useSectionsErrors: PropTypes.func,
	onActionUpdate: PropTypes.func,
};
